var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"doc-main"},[_c('el-aside',{staticClass:"doc-main__aside aside-container",class:{
      'doc-main__aside': true,
      'aside-container': true,
      'common-development-tools': _vm.computeResizeButtonVisible,
    },style:({ width: _vm.computeAsideWidth + 'px' })},[_c('AsideMenu',{attrs:{"isShrink":_vm.isShrink}}),(_vm.computeResizeButtonVisible)?_c('div',{staticClass:"aside__resize-button",style:({ left: _vm.computeResizeButtonLeft + 'px' }),on:{"click":_vm.onClickResizeButton}},[_c('i',{class:_vm.computeResizeButtonIconClassName})]):_vm._e()],1),_c('el-main',[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }